import axios from "axios";
import { Eye, EyeOff, Lock, Mail } from "lucide-react";
import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../../assets/css/customer/auth/Login.css";
import AppContext from "../../../context/AppContext";

export default function AdminLogin() {
  const { setLoggedInAdmin, RegExpChecker, baseUrl, setAuthToken } =
    useContext(AppContext);
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  // ── Submit ─────────────────────────────────────────────────
  const handleSignIn = () => {
    // const emailErr = RegExpChecker("email", email);
    // const passwordErr = RegExpChecker("password", password);
    // const errs = { ...emailErr, ...passwordErr };

    // const hasErrors = Object.values(errs).some(Boolean);
    // if (hasErrors) {
    //   setErrors(errs);
    //   return;
    // }

    setErrors({});
    setIsSubmitting(true);

    const formData = new FormData();
    formData.append("email", email);
    formData.append("password", password);

    axios
      .post(`${baseUrl}/admin/auth/adminLogin`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        console.log(response.data);

        if (response.data.success) {
          setLoggedInAdmin(response.data.admin);
          // localStorage.setItem("Admin", JSON.stringify(response.data.admin));
          localStorage.setItem("authToken", response.data.token);
          setAuthToken(response.data.token);

          setIsSubmitting(false);
          navigate("/admin/dashboard");
        } else {
          setIsSubmitting(false);
          setErrors({
            general: response.data.message || "Login failed. Please try again.",
          });
        }
      })
      .catch((error) => {
        setIsSubmitting(false);
        console.log(error);
      });
  };

  return (
    <form
      className="lm-overlay"
      onSubmit={(e) => {
        e.preventDefault();
        handleSignIn();
      }}
      role="dialog"
      aria-modal="true"
      aria-label="Login"
    >
      <div className="lm-modal">
        {/* Header */}
        <div className="lm-header">
          <h2 className="lm-title">Welcome back</h2>
        </div>

        {/* Body */}
        <div className="lm-form-body">
          {errors.general && (
            <div className="lm-general-error">⚠ {errors.general}</div>
          )}

          {/* Email */}
          <div className="lm-field">
            <label className="lm-label" htmlFor="lm-email">
              Email
            </label>
            <div className="lm-input-wrap">
              <span className="lm-input-icon">
                <Mail size={16} />
              </span>
              <input
                id="lm-email"
                type="email"
                className={`lm-input${errors.email ? " lm-input-error" : ""}`}
                placeholder="you@example.com"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setErrors((prev) => ({
                    ...prev,
                    ...RegExpChecker("email", e.target.value),
                  }));
                }}
                autoComplete="email"
              />
            </div>
            {errors.email && (
              <span className="lm-error-msg">⚠ {errors.email}</span>
            )}
          </div>

          {/* Password */}
          <div className="lm-field">
            <label className="lm-label" htmlFor="lm-pw">
              Password
            </label>
            <div className="lm-input-wrap">
              <span className="lm-input-icon">
                <Lock size={16} />
              </span>
              <input
                id="lm-pw"
                type={showPw ? "text" : "password"}
                className={`lm-input${errors.password ? " lm-input-error" : ""}`}
                placeholder="Your password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setErrors((prev) => ({
                    ...prev,
                    ...RegExpChecker("password", e.target.value),
                  }));
                }}
                autoComplete="current-password"
              />
              <button
                className="lm-eye-btn"
                type="button"
                onClick={() => setShowPw((p) => !p)}
                aria-label={showPw ? "Hide password" : "Show password"}
              >
                {showPw ? <Eye size={16} /> : <EyeOff size={16} />}
              </button>
            </div>
            {errors.password && (
              <span className="lm-error-msg">⚠ {errors.password}</span>
            )}
          </div>

          {/* Submit */}
          <button
            className="lm-submit-btn"
            type="submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Signing in…" : "Sign In"}
          </button>
        </div>
      </div>
    </form>
  );
}
